const index= () =>import('@/components/chunjie2022/Index')
const PaySuccess= () =>import('@/components/chunjie2022/PaySuccess')
const LoginBottom= () =>import('@/components/base/LoginBottom')
export default[
    {
        path: '/chunjie/index',
        component: index,
        meta: {title: '春节活动'}
    },
    {
        path: '/chunjie/pay_success',
        component: PaySuccess,
        meta: {title: '支付成功'}
    },

]




// WEBPACK FOOTER //
// ./src/router/chunjie2022Router.js